import constants from "src/constants";

function styleImageWrapper(
  align: string,
  backgroundColor: string,
  backgroundPattern: string
) {
  return {
    alignItems: (function () {
      switch (align) {
        case `start`:
          return `flex-start`;
        case `center`:
          return `center`;
        case `end`:
          return `flex-end`;
        case `stretch`:
          return `stretch`;
        case `baseline`:
          return `baseline`;
        case `normal`:
          return `normal`;
        default:
          return `center`;
      }
    })(),
    backgroundColor: (function () {
      switch (backgroundColor) {
        case `color_1`:
          return constants.Theme.white;
        case `color_2`:
          return constants.Theme.greyLighter;
        case `color_3`:
          return constants.Theme.greyLight;
        case `color_4`:
          return constants.Theme._default;
        case `color_5`:
          return constants.Theme.primary;
        case `color_6`:
          return constants.Theme.primaryActive;
        case `color_7`:
          return constants.Theme.secondary;
        case `color_8`:
          return constants.Theme.secondaryActive;
        case `color_9`:
          return constants.Theme.transparent;
        default:
          return constants.Theme.transparent;
      }
    })(),
    backgroundImage: (function () {
      switch (backgroundPattern) {
        case `pattern_1`:
          return `transparent`;
        case `pattern_2`:
          return `transparent`;
        case `pattern_3`:
          return `transparent`;
        case `pattern_4`:
          return `transparent`;
        case `pattern_5`:
          return `transparent`;
        case `pattern_6`:
          return `transparent`;
        case `pattern_7`:
          return `transparent`;
        case `pattern_8`:
          return `transparent`;
        case `pattern_9`:
          return `transparent`;
        default:
          return `transparent`;
      }
    })(),
  };
}

export default styleImageWrapper;
